var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":require("../assets/loader.svg"),"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }